module.exports = __webpack_public_path__ + "img/exporo_icon.73e83e3a.svg";